module.exports = __webpack_public_path__ + "img/barra-azul.d58dcf85.svg";